import React, { useEffect, useRef, useState } from "react"
import api from "services/api.service"
import { userService } from "services/user.service"
import {
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap"
import { toast } from "react-toastify"
import {
  swalWithConfirmAndCancelButtons,
  swalWithConfirmButton,
} from "components/custom/swal"
import NameAvatar from "components/custom/nameAvatar"
import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"

const ModelsGrid = ({ models, props, reloadData, scenarioTypes }) => {
  var gridRef = useRef(null)
  const currentUser = userService.getLoggedInUser()
  const [showActionsDropdown, setShowActionsDropdown] = useState(false)

  const handleModelPress = (e, model) => {
    e && e.preventDefault()
    if (currentUser.roleID < 10) {
      props.history.push(`/projects/${model.scenarioID}`)
    } else {
      props.history.push(`/editModel/${model.scenarioID}`)
    }
  }

  const handleAltPress = (e, model) => {
    e && e.preventDefault()
    props.history.push(`/projects/${model.scenarioID}`)
  }

  const handleParticipantsPress = (e, model) => {
    e && e.preventDefault()
    props.history.push(`/participants/${model.scenarioID}`)
  }

  const columns = [
    {
      type: "checkbox",
      width: 50,
    },
    {
      headerText: "Portfolio Type",
      field: "scenarioType",
      width: 150,
      filter: {
        type: "Excel",
        itemTemplate: data => {
          return (
            <div
              style={{ lineHeight: "20px" }}
              dangerouslySetInnerHTML={{
                __html: data.scenarioType,
              }}
            ></div>
          )
        },
      },
      template: data => (
        <div
          style={{ lineHeight: "20px" }}
          dangerouslySetInnerHTML={{
            __html: data.scenarioType,
          }}
        ></div>
      ),
    },
    {
      headerText: "Portfolio Manager",
      field: "portfolioManager",
      width: 200,
      template: data => (
        <NameAvatar
          fullName={data.portfolioManager}
          showName={true}
          base64Image={data.portfolioManagerPhotoBase64}
        />
      ),
    },
    {
      headerText: "Portfolio",
      field: "scenarioName",
      width: 200,
      template: data => (
        <a href="#" onClick={e => handleModelPress(e, data)}>
          {data.scenarioName}
        </a>
      ),
    },

    {
      headerText: `View`,
      field: "scenarioID",
      width: 250,
      allowFiltering: false,
      allowSorting: false,
      template: data => (
        <>
          <a href="#" onClick={e => handleAltPress(e, data)}>
            {data.alternativeName}s;
          </a>
          <a
            href="#"
            onClick={e => handleParticipantsPress(e, data)}
            style={{ marginLeft: "10px" }}
          >
            Team Members
          </a>
        </>
      ),
    },
    {
      headerText: "Locked",
      field: "lockBit",
      textAlign: "Center",
      width: 100,
      template: data => {
        return data.lockBit == null ? (
          ""
        ) : data.lockBit == 1 ? (
          <i className="fas fa-lock" style={{ color: "red" }}></i>
        ) : (
          ""
        )
      },
    },
    {
      headerText: "Backup",
      field: "backupBit",
      textAlign: "Center",
      width: 100,
      template: data => {
        return data.backupBit == 0 ? (
          ""
        ) : (
          <span style={{ color: "red" }}>
            <b>Backup</b>
          </span>
        )
      },
    },
    {
      headerText: "Active",
      field: "inactive",
      textAlign: "Center",
      width: 100,
      template: data => {
        return data.inactive == 0 ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>
            <b>No</b>
          </span>
        )
      },
    },
    {
      headerText: "Last modified",
      field: "lastUpdateDT",
      width: 100,
      template: data => {
        let date = new Date(data.lastUpdateDT)
        return (
          date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()
        )
      },
    },
  ]

  const deleteSelected = () => {
    swalWithConfirmAndCancelButtons
      .fire({
        title: `Are you sure you want to delete the selected projects?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      })
      .then(async result => {
        if (result.isConfirmed) {
          let selected = gridRef.current.getSelectedRecords()
          if (selected.length > 0) {
            let copy = [...selected]
            let tasks = copy.map(x => async () => {
              return await api.deleteScenario(currentUser.userID, x.scenarioID)
            })
            await Promise.all(tasks.map(t => t()))
            reloadData()
            toast.success("Projects deleted successfully")
          }
        }
      })
  }

  const updateSelected = async (prop, value) => {
    let selected = gridRef.current.getSelectedRecords()
    if (selected.length > 0) {
      let copy = selected.map(x => {
        x[prop] = value
        return x
      })
      let tasks = copy.map(x => async () => {
        return await api.updateScenario(currentUser.userID, x)
      })
      await Promise.all(tasks.map(t => t()))
      reloadData()
      toast.success("Projects saved successfully")
    }
  }

  return (
    <Card>
      <CardBody>
        {models.length > 0 && (
          <>
            <Row>
              <Col
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                {currentUser.roleID >= 10 && (
                  <div>
                    <Dropdown
                      isOpen={showActionsDropdown}
                      toggle={() => {
                        if (!showActionsDropdown) {
                          let selected = gridRef.current.getSelectedRecords()
                          if (selected.length > 0) {
                            setShowActionsDropdown(!showActionsDropdown)
                          } else {
                            swalWithConfirmButton.fire({
                              title: `You must select at least one model first`,
                              icon: "warning",
                              showCancelButton: false,
                              confirmButtonText: "Ok",
                            })
                          }
                        } else {
                          setShowActionsDropdown(!showActionsDropdown)
                        }
                      }}
                    >
                      <DropdownToggle
                        tag="button"
                        className="btn btn-sm btn-outline-primary"
                      >
                        Batch Actions <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={() => updateSelected("inactive", false)}
                        >
                          <i className="mdi mdi-arrow-right-drop-circle" />{" "}
                          Activate
                        </DropdownItem>

                        <DropdownItem onClick={() => deleteSelected()}>
                          <i className="mdi mdi-trash-can-outline" /> Delete
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => updateSelected("backupBit", true)}
                        >
                          <i className="mdi mdi-database-arrow-down-outline" />{" "}
                          Declare as Backup
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => updateSelected("inactive", true)}
                        >
                          <i className="mdi mdi-arrow-down-drop-circle-outline" />{" "}
                          De-activate
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => updateSelected("lockBit", true)}
                        >
                          <i className="mdi mdi-lock" /> Lock
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => updateSelected("backupBit", false)}
                        >
                          <i className="mdi mdi-database-export" /> Undeclare as
                          Backup
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => updateSelected("lockBit", false)}
                        >
                          <i className="mdi mdi-lock-open-outline" /> Unlock
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                )}
              </Col>
            </Row>
            <SyncfusionGrid
              gridRef={gridRef}
              columns={columns}
              data={models}
              selectionSettings={{
                type: "Multiple",
                mode: "Row",
                checkboxOnly: true,
              }}
            />
          </>
        )}
      </CardBody>
    </Card>
  )
}

export default ModelsGrid
